/**
 *  GENERÁLT SZÁMLAKÉP egy NAV Online Számla (OSA) számlából – önálló, nyomtatható ablakban.
 *
 *  Egy helyen, mert három képernyő használja: a két könyvelőablak (egyszeres, kettős) és a
 *  Naplók „Számlakép megtekintése" művelete. (Korábban a két könyvelőablakban külön másolat élt.)
 */
import { NaploService } from './naplo.service';

const fmt = (n: any) => { const x = Number(n); return Number.isFinite(x) ? x.toLocaleString('hu-HU') : ''; };

//  Fizetési mód magyarul – a NAV Online Számla kódjai (TRANSFER/CASH/…) ÉS a belső kódok
//  (atutalas/keszpenz/…) is, ismeretlennél a nyers érték.
const FIZMOD: Record<string, string> = {
  TRANSFER: 'Átutalás', CASH: 'Készpénz', CARD: 'Bankkártya', VOUCHER: 'Utalvány', OTHER: 'Egyéb',
  atutalas: 'Átutalás', keszpenz: 'Készpénz', kartya: 'Bankkártya', utalvany: 'Utalvány', egyeb: 'Egyéb',
};
const fizmodNev = (v: any) => (v ? (FIZMOD[String(v)] || FIZMOD[String(v).toUpperCase()] || String(v)) : '');

export function szamlakepAblakba(w: Window | null, sz: any): void {
  if (!w || !sz) return;
  const sorok = (sz.tetelsorok || []).map((t: any, i: number) => `<tr>
    <td>${t.sorszam || i + 1}</td><td>${t.megnevezes || ''}</td>
    <td style="text-align:right">${t.mennyiseg ?? ''}</td><td>${t.egyseg || ''}</td>
    <td style="text-align:right">${fmt(t.egysegar)}</td><td style="text-align:right">${t.afa_kulcs ?? ''}%</td>
    <td style="text-align:right">${fmt(t.netto)}</td><td style="text-align:right">${fmt(t.brutto)}</td></tr>`).join('') ||
    `<tr><td colspan="8" style="text-align:center;color:#888">Nincsenek tételsorok (csak fejléc-adat).</td></tr>`;
  const afaSorok = (sz.sorok || []).map((s: any) => `<tr><td style="text-align:right">${s.afa_kulcs ?? ''}%</td>
    <td style="text-align:right">${fmt(s.netto)}</td><td style="text-align:right">${fmt(s.afa)}</td><td style="text-align:right">${fmt(s.brutto)}</td></tr>`).join('');
  const modositoFej = (sz.eredeti_szamlaszam || sz.originalInvoiceNumber)
    ? `<div style="margin:8px 0;padding:8px 12px;background:#fef3c7;border-left:4px solid #d97706;font-size:12px">
         <b>Módosító/helyesbítő számla</b> – eredeti számla: <b>${sz.eredeti_szamlaszam || sz.originalInvoiceNumber}</b></div>` : '';
  w.document.open();
  w.document.write(`<!doctype html><html lang="hu"><head><meta charset="utf-8"><title>Számla – ${sz.szamlaszam || ''}</title>
    <style>
      body{font-family:Arial,Helvetica,sans-serif;color:#0f172a;margin:24px;font-size:13px}
      .fej{display:flex;justify-content:space-between;gap:24px;margin-bottom:14px}
      .cimke{font-size:11px;text-transform:uppercase;color:#0f766e;font-weight:700}
      .nev{font-size:16px;font-weight:700;margin:2px 0}
      .meta{font-size:12px;color:#475569}
      h1{font-size:18px;color:#134e4a;border-top:2px solid #0f766e;border-bottom:2px solid #0f766e;padding:8px 0;margin:10px 0}
      .datumok{display:flex;gap:18px;flex-wrap:wrap;font-size:12px;margin-bottom:10px}
      table{width:100%;border-collapse:collapse;margin-top:8px;font-size:12px}
      th,td{border-bottom:1px solid #e2e8f0;padding:5px 7px;text-align:left}
      th{background:#f0fdfa;color:#0f766e}
      tfoot td{font-weight:700;background:#ecfeff;border-top:2px solid #0f766e}
      .osszesito{max-width:380px;margin-left:auto}
      @media print{button{display:none}}
    </style></head><body>
    <button onclick="window.print()" style="float:right;padding:6px 14px;background:#0f766e;color:#fff;border:0;border-radius:6px;cursor:pointer">Nyomtatás</button>
    <div class="fej">
      <div><div class="cimke">Szállító</div><div class="nev">${sz.supplierName || ''}</div>
        <div class="meta">Adószám: ${sz.supplierTax || ''}</div><div class="meta">${sz.supplierAddr || ''}</div></div>
      <div><div class="cimke">Vevő</div><div class="nev">${sz.customerName || ''}</div>
        <div class="meta">Adószám: ${sz.customerTax || ''}</div><div class="meta">${sz.customerAddr || ''}</div></div>
    </div>
    <h1>Számla – ${sz.szamlaszam || ''}</h1>
    ${modositoFej}
    <div class="datumok"><span><b>Kelt:</b> ${sz.issueDate || ''}</span><span><b>Teljesítés:</b> ${sz.deliveryDate || ''}</span>
      <span><b>Fiz. határidő:</b> ${sz.paymentDate || ''}</span><span><b>Pénznem:</b> ${sz.deviza || 'HUF'}</span>
      ${(sz.paymentMethod || sz.fizmod) ? `<span><b>Fizetési mód:</b> ${fizmodNev(sz.paymentMethod || sz.fizmod)}</span>` : ''}</div>
    <table><thead><tr><th>#</th><th>Megnevezés</th><th style="text-align:right">Menny.</th><th>Egység</th>
      <th style="text-align:right">Egységár</th><th style="text-align:right">ÁFA%</th><th style="text-align:right">Nettó</th><th style="text-align:right">Bruttó</th></tr></thead>
      <tbody>${sorok}</tbody></table>
    <table class="osszesito"><thead><tr><th style="text-align:right">ÁFA%</th><th style="text-align:right">Nettó</th><th style="text-align:right">ÁFA</th><th style="text-align:right">Bruttó</th></tr></thead>
      <tbody>${afaSorok}</tbody>
      <tfoot><tr><td>Összesen</td><td style="text-align:right">${fmt(sz.netto)}</td><td style="text-align:right">${fmt(sz.afa)}</td><td style="text-align:right">${fmt(sz.brutto)}</td></tr></tfoot></table>
    </body></html>`);
  w.document.close();
}


/** Az OSA-számla képe szám és irány alapján: előbb nyit (popup-blokkolás ellen), aztán betölt. */
export async function osaSzamlakepNyit(naplo: NaploService, ugyfelId: string, szamlaszam: string, irany: 'inbound' | 'outbound'): Promise<void> {
  const w = window.open('', 'szamlakep', 'width=820,height=900,scrollbars=yes');
  if (w) w.document.write('<p style="font-family:sans-serif;padding:20px">Számlakép betöltése…</p>');
  try {
    const p = new URLSearchParams({ szamlaszam, direction: irany });
    const r: any = await naplo.get(`/osa/szamlakep/${ugyfelId}?${p.toString()}`);
    szamlakepAblakba(w, r.szamla);
  } catch (e) {
    if (w) w.close();
    throw e;
  }
}
